import { TAnalyticsEnvironmentVars, TPlani8EnvironmentVars, TReportingEnvironmentVars } from '@monorepo/types';

export const environment: TPlani8EnvironmentVars = {
  appType: 'PT_APP',
  production: false,
  mode: 'kalpha',
  protocol: 'https://',
  service_host: 'kalpha-n-planning-tool-web-external.strawmine.com',
  reports_host: 'analytics.kalpha.strawmine.com',
  plani8: '/plani8/ext',
  auth_services: '/auth_services/ext',
  unified_login: 'auth.strawmine.com',
  data_gateway: '/app_data_gateway_n2/ext',
};

export const reportsEnvironment: TReportingEnvironmentVars = {
  appType: 'PT_APP',
  reports_host: environment.service_host,
  reports_data_gateway: environment.data_gateway,
  protocol: environment.protocol,
};

export const analyticsEnvironment: TAnalyticsEnvironmentVars = {
  appType: 'PT_APP',
  host: environment.service_host,
  data_gateway: environment.data_gateway,
  protocol: environment.protocol,
};
